import { FC } from 'react';

import { useFeaturesLoyaltyDashboard } from './use-feature-loyalty-dashboard';

export type WidgetMap = FC;
export interface ILoyaltyDashboardViewProps {
  /** Array of widgets to populate dashboard view */
  widgets: Array<WidgetMap>;
  /** Dismisses loyalty dashboard */
  handleDismiss(): void;
}

export enum LoyaltyWidgets {
  DoubleButton = 'doubleButtonWidget',
  Greeting = 'greetingWidget',
  History = 'historyWidget',
  Links = 'linkWidget',
  MarketingTiles = 'marketingTileGroupWidget',
  PointsMeter = 'pointsMeterWidget',
  Reward = 'pointsAndRewardsWidget',
  Tiers = 'tiersWidget',
  Notifications = 'notificationsWidget',
}

type WidgetData = NonNullable<ReturnType<typeof useFeaturesLoyaltyDashboard>['data']>;

export type WidgetKeys = NonNullable<WidgetData['widgets']>;

export const hasComponentKey = <T extends Object>(
  widget: T & { componentKey?: string | null }
): widget is T & { componentKey: string } => {
  return !!widget?.componentKey;
};
